import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Colors } from 'services/ColorService';

interface IProps {
  /** Optional detail appended to the tooltip (e.g. the overdue amount). */
  extra?: string;
}

/**
 * Inline «LMS access blocked» marker for student lists (spec 0003 follow-up):
 * a red lock icon with a localized tooltip. Purely presentational — the row
 * decides whether to render it from `isLmsBlocked`.
 */
export const LmsBlockBadge = memo<IProps>(({ extra }) => {
  const { t } = useTranslation();
  const title = extra
    ? `${t('pages.studentDetail.lmsBlock.blocked')} · ${extra}`
    : t('pages.studentDetail.lmsBlock.blocked');

  return (
    <Tooltip title={title}>
      <LockIcon aria-label={t('pages.studentDetail.lmsBlock.blocked')} />
    </Tooltip>
  );
});

const LockIcon = styled(LockOutlined)`
  color: ${Colors.Red};
  font-size: 14px;
  margin-left: 6px;
  vertical-align: middle;
`;
